import { ReorderAccountsDto } from "../common/dto/entity/reorder-accounts.dto";
import { Entity } from "../common/types/entity";
import { UpdateEntityAddressDto } from "../common/dto/entity/update-entity-address.dto";
import { Address } from "../common/types/embeddable/address";
import { CreateEntityDto } from "../common/dto/entity/create-entity.dto";
import { backendClient, unwrapResponse } from "./backendClient";

export async function createEntity(data: CreateEntityDto): Promise<Entity> {
    return unwrapResponse(await backendClient.post("/entity", data));
}

export async function reorderEntityAccounts(data: ReorderAccountsDto) {
    await backendClient.post("/entity/reorder-accounts", data);
}

export async function getAddress(entity: Entity): Promise<Address | null> {
    return unwrapResponse(
        await backendClient.get(`/entity/${entity.id}/address`),
    );
}

export async function updateAddress(
    data: UpdateEntityAddressDto,
): Promise<Address> {
    return unwrapResponse(await backendClient.put("/entity/address", data));
}
